// Mock data for Kadtech HR Solutions landing page

import { text } from "framer-motion/client";
import hdfcLogo from "../assets/hdfc-bank.jpeg";
import emamiLogo from "../assets/emami.jpeg";
import qualcommLogo from "../assets/qualcomm.jpeg";
import mediatekLogo from "../assets/mediatek.jpeg";
import justdialLogo from "../assets/justdial.jpeg";
import techMahindraLogo from "../assets/tech-mahindra.jpeg";
import bigCityLogo from "../assets/bigcity.jpeg";
import karnatakaBankLogo from "../assets/karnataka-bank.jpeg";

export const navMenu = [
  {
    label: 'Jobs by Category',
    items: ['IT/Software Jobs','Core Technical Jobs','Govt Jobs','MBA Jobs','Internship Jobs','Diploma Jobs','Research Jobs','Finance & Accounting Jobs','BPO Jobs','Part Time Jobs','Health Care Jobs','Walkin Jobs','Teaching Jobs','Pharma Jobs','Journalism Jobs','Tech Support Jobs','Hospitality Jobs','Retail Jobs','BSc/BCA/BBM Jobs','Sales And Marketing','More Categories']
  },
  {
    label: 'Jobs by Courses',
    items: ['BE/B.Tech','ME/M.Tech','B.Com','BBA/BBM','BCA','BSc','Diploma','B.Arch','BSW','M.Chirurgiae','MPEd','B.P.Ed','MVSc','BFA','B.FashionTech','B.Design','MS','More Courses']
  },
  {
    label: 'Jobs by Roles',
    items: ['Accountant','Architect Jobs','BPO / Telecaller','Tech Support','Content Writer','Fashion Designer','Data Entry','SEO / Social Media','HR / Admin','Engineer (Core, Non-IT)','Sales Executive','IT Mobile Developer','IT Software-Engineer','Management Trainee','Design / Animation','Teacher / Trainer','Delivery Executive','Chef / Cook','Counsellor','More Roles']
  },
  {
    label: 'Jobs by Cities',
    items: ['Jobs in Ahmedabad','Jobs in Bangalore','Jobs in Chennai','Jobs in Delhi','Jobs in Hyderabad','Jobs in Kolkata','Jobs in Mumbai','Jobs in Pune','Jobs in Noida','Jobs in Gurgaon','Jobs in Chandigarh','Jobs in Panaji','Jobs in Patna','Jobs in Bhopal','Jobs in Bhubaneswar','Jobs in Jaipur','More Cities']
  },
  {
    label: 'Jobs by Skills',
    items: ['CCNA Jobs','Embedded System Jobs','Finance Jobs','HR Jobs','Mainframe Jobs','Marketing Jobs','Oracle Jobs','SAP Jobs','Software Testing Jobs','Unix Jobs','SEO Jobs','Delivery Jobs','C Jobs','CAD Jobs','C++ Jobs','DSP Jobs','HTML Jobs','Java Jobs','More Skills']
  },
  {
    label: 'Jobs by Companies',
    items: ['WBPSC Recruitment','UPPSC Recruitment','TNPSC Recruitment','RPSC Recruitment','PPSC Recruitment','Police Recruitment','OPSC Recruitment','Indian Navy Recruitment','Railway Recruitment','Indian Army Recruitment','Air Force Recruitment','Air India Recruitment','More Companies']
  }
];

export const cities = ['Bengaluru','Mumbai','New Delhi','Hyderabad','Chennai','Kolkata','Pune','Ahmedabad','Jaipur','Gurgaon','Noida','Chandigarh','Lucknow','Patna','Bhopal','Kochi','Coimbatore','Bhubaneswar','Indore','Nagpur','Visakhapatnam','Surat','Vadodara','Faridabad','Ghaziabad'];

export const topRoles = [
  { title: 'Sales / Marketing', count: 73, isNew: false },
  { title: 'Sales Executive', count: 45, isNew: false },
  { title: 'Mechanic', count: 25, isNew: true },
  { title: 'Engineer', count: 22, isNew: false },
  { title: 'Retail / Store Executive', count: 20, isNew: true },
  { title: 'Data Entry / Back Office', count: 13, isNew: false },
  { title: 'Accountant', count: 10, isNew: false },
  { title: 'BPO / Customer care', count: 8, isNew: false },
  { title: 'Customer Service / Tech Support', count: 8, isNew: false },
  { title: 'Management Trainee', count: 6, isNew: true },
  { title: 'Tech Support', count: 6, isNew: false },
  { title: 'HR', count: 5, isNew: false },
  { title: 'IT Hardware Engineer', count: 5, isNew: false }
];

export const topCompanies = [
  {
    name: "HDFC BANK",
    logo: hdfcLogo,
    bg: "#ffffff",
    width: "180px",
    height: "70px",
  },
  {
    name: "EMAMI",
    logo: emamiLogo,
    bg: "#ffffff",
    width: "250px",
    height: "100px",
  },
  {
    name: "QUALCOMM",
    logo: qualcommLogo,
    bg: "#ffffff",
    width: "140px",
    height: "50px",
  },
  {
    name: "MEDIATEK",
    logo: mediatekLogo,
    bg: "#ffffff",
    width: "140px",
    height: "60px",
  },
  {
    name: "JUST DIAL",
    logo: justdialLogo,
    bg: "#ffffff",
    width: "220px",
    height: "100px",
  },
  {
    name: "TECH MAHINDRA",
    logo: techMahindraLogo,
    bg: "#ffffff",
    width: "160px",
    height: "80px",
  },
  {
    name: "BIG CITY PROMOTIONS",
    logo: bigCityLogo,
    bg: "#ffffff",
    width: "140px",
    height: "60px",
  },
  {
    name: "KARNATAKA BANK",
    logo: karnatakaBankLogo,
    bg: "#ffffff",
    width: "150px",
    height: "60px",
  },
];

export const recentJobs = [
  { title: 'FRANCHISE ASSOCIATE', company: 'Grasim Industries Limited', city: 'Bengaluru' },
  { title: 'Senior Engineer Purchase', company: 'Rittal Private Limited', city: 'Bengaluru' },
  { title: 'O And M Technician', company: 'Dakshin Gujrat Smart Metering Pvt Ltd', city: 'Bharuch' },
  { title: 'Sales Officer 3 Wheeler Loan', company: 'RBA Finance Pvt Ltd', city: 'Lucknow' },
  { title: 'Production Trainee', company: 'Beetel Teletech Limited', city: 'Bhagalpur' },
  { title: 'Associate Software Engineer', company: 'Kadtech Digital', city: 'Bengaluru' },
  { title: 'Operator', company: 'Dixon Technologies India Limited', city: 'Dehradun' },
  { title: 'ASST. MANAGER - OPERATIONS', company: 'Okaya & Co India Pvt Ltd', city: 'Central Delhi' },
  { title: 'Sr Sales Associate', company: 'TATA Play Broadband Pvt Ltd', city: 'Kolkata' },
  { title: 'Sr Sales Officer', company: 'TATA Play Broadband Pvt Ltd', city: 'New Delhi' }
];

export const cityJobCounts = [
  { city: 'New Delhi', count: 77 },
  { city: 'Mumbai', count: 64 },
  { city: 'Chennai', count: 46 },
  { city: 'Bengaluru', count: 40 },
  { city: 'Kolkata', count: 34 },
  { city: 'Hyderabad', count: 19 },
  { city: 'Pune', count: 28 },
  { city: 'Ahmedabad', count: 22 }
];

export const testimonials = [
  {
    name: 'Vignesh',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Vignesh&backgroundColor=b6e3f4',
    text: 'My greatest concern of earning revenue got solved when I entered the organization. It brings me pride and satisfaction to be associated with such a great company. I would like to thank Kadtech for being so approachable and punctual while helping me change my life. #MyKadtechFamily'
  },
  {
    name: 'Kishore',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Kishore&backgroundColor=ffdfbf',
    text: 'Never before did I ever believe that I would be happy in one organization for such a long time. This however is possible due to how wonderful an organization I got a job in. I have managed to achieve stability and job satisfaction. Thank you Kadtech. #MyKadtechFamily'
  },
  {
    name: 'Bhawana',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Bhawana&backgroundColor=c0aede',
    text: 'My experience was filled with learning and personal growth. Its an organization that is very supportive in nature and you can reach out to even the senior members for guidance. Working here brought me a lot of pride and happiness.'
  },
  {
    name: 'Manishan Gaur',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Manishan&backgroundColor=d1d4f9',
    text: 'A major concern for me used to be my confidence on how to tackle situations. Upon joining, I saw personal growth in the right direction that gave me a confident mind and skill set. Thank you Kadtech! #MyKadtechFamily'
  },
  {
    name: 'Arun Yadav',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Arun&backgroundColor=ffd5dc',
    text: 'After completing my BSc I found myself in desperate search of employment. That is when I was recommended to seek help from Kadtech, this proved to be amazing for my career. I am thankful to Kadtech and their members. #MyKadtechFamily'
  },
  {
    name: 'A. Thoufiq',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Thoufiq&backgroundColor=b6e3f4',
    text: 'I am eternally grateful for Kadtech for steering my career in the right direction. I have seen great amounts of personal growth within myself after getting the job. Right directions and right mindsets are important and I have learnt both here.'
  },
  {
    name: 'Suhas J',
    role: 'Kadtech Associate',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Suhas&backgroundColor=ffdfbf',
    text: 'Being a skilled student it was important for me to take a step in the right direction for my first job. My very first attempt post signing up on Kadtech I got a job. The experience has been life changing. #MyKadtechFamily'
  }
];

export const whyUs = [
  { title: '✔ Industry Expertise', desc: 'Experienced recruiters across multiple industries.' },
  { title: '✔ Fast Turnaround Time', desc: 'Quick sourcing and faster closures.' },
  { title: '✔ Quality Candidates', desc: 'Pre-screened and interview-ready professionals.' },
  // { title: '✔ PAN India Hiring', desc: 'Serving clients across India.' },
  // { title: '✔ Dedicated Recruitment Team', desc: 'Single Point of Contact for every client.' },
  // { title: '✔ Customized Hiring Solutions', desc: 'Recruitment plans designed according to business needs.' },
  { title: '✔ Affordable Pricing', desc: 'Flexible engagement models suitable for startups, SMEs, and large enterprises.' }
];

export const stats = {
  Happy_Clients: '100+',
  Placements: '5000+',
  Client_Satisfaction: '98%'
};
